import { createContext, useContext } from "react";

export interface QuickLockSettings {
  timeoutMinutes: number;
  lockOnHide: boolean;
}

export interface QuickLockState {
  locked: boolean;
  settings: QuickLockSettings;
  lock: () => void;
  unlock: () => void;
  updateSettings: (settings: QuickLockSettings) => void;
}

export const DEFAULT_QUICK_LOCK_SETTINGS: QuickLockSettings = {
  timeoutMinutes: 5,
  lockOnHide: false,
};

export const QuickLockContext = createContext<QuickLockState>({
  locked: false,
  settings: DEFAULT_QUICK_LOCK_SETTINGS,
  lock: () => undefined,
  unlock: () => undefined,
  updateSettings: () => undefined,
});

export function useQuickLock() {
  return useContext(QuickLockContext);
}
